/**
 * The Firebase app and auth, opened once.
 *
 * Firestore is deliberately **not** here: it lives in `data/firestore.ts`, because opening
 * it means naming the database (`studio`, not `(default)`) and that belongs with the rest
 * of the data layer's conventions.
 */

import { getApp, getApps, initializeApp } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import type { Auth } from 'firebase/auth';

import { EMULATOR, studioEnv } from './env.js';

let cached: { app: FirebaseApp; auth: Auth } | null = null;

export function firebaseApp(): FirebaseApp {
  const env = studioEnv();
  return getApps().length > 0
    ? getApp()
    : initializeApp({
        apiKey: env.apiKey,
        authDomain: env.authDomain,
        projectId: env.projectId,
        storageBucket: env.storageBucket,
        messagingSenderId: env.messagingSenderId,
        appId: env.appId,
      });
}

export function firebase(): { app: FirebaseApp; auth: Auth } {
  if (cached === null) {
    const app = firebaseApp();
    const auth = getAuth(app);
    if (studioEnv().useEmulator) {
      connectAuthEmulator(auth, EMULATOR.authUrl, { disableWarnings: true });
    }
    cached = { app, auth };
  }
  return cached;
}
